import Vue from 'vue'
import Vuex from 'vuex'
import appsetting from '@/store/modules/app.settings'
import auth from '@/store/modules/auth'
import rvtabs from '@/store/modules/tab'
import dashboard from '@/store/modules/dashboard'
import post from '@/store/modules/post'
import searchresult from '@/store/modules/search'
import analyst from '@/store/modules/analyst'
Vue.use(Vuex)
export default new Vuex.Store({
	modules: {
		appsetting,
		rvtabs,
		auth,
		dashboard,
		post,
		searchresult,
		analyst
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js